import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import apiFetch from "../../../shared/services/apiClient";
import ProveedorStepper from "../components/Stepper/ProveedorStepper";

export default function EditProveedorPage() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [initial, setInitial] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    apiFetch(`/api/proveedores/proveedor/${id}/`)
      .then(async (r) => {
        if (!r.ok) { setError(t("proveedores.errorCargarProveedor")); return; }
        const data = await r.json();
        setInitial({ ...data, telefonos: data.telefonos || [] });
      })
      .catch(() => setError(t("proveedores.errorConexion")))
      .finally(() => setLoading(false));
  }, [id, t]);

  if (loading) return (
    <div style={{ padding: 40, textAlign: "center", color: "var(--text-muted)" }}>
      <i className="fa-solid fa-circle-notch fa-spin" style={{ marginRight: 8 }} />
      {t("proveedores.cargandoProveedor")}
    </div>
  );

  if (error) return (
    <div style={{ padding: 40, textAlign: "center", color: "#f87171" }}>
      <p>{error}</p>
      <Link to="/proveedores" style={{ color: "#f97316" }}>← {t("proveedores.volverProveedores")}</Link>
    </div>
  );

  return <ProveedorStepper initial={initial} proveedorId={id} />;
}
